<template>
  <el-tooltip v-if="isVisible()" class="item" effect="dark" :content="$t('outbound.shuttleInbound.setAsArrived')" placement="top">
    <span>
      <i class="el-icon-box icon-action" @click="handleSubmit()" />
    </span>
  </el-tooltip>
</template>

<script>
import { Message } from 'element-ui';
import { mapActions } from 'vuex';
import constants from '@/utils/constants';
import { SHUTTLE_INBOUND_SEARCH, SHUTTLE_INBOUND_SET_AS_ARRIVED } from '@/store/actions';

export default {
  name: 'SetAsArrived',
  props: {
    shuttleLoadId: {
      type: Number,
      default: null
    },
    shuttleLoadStatus: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      releasedStatus: constants.SHUTTLE_LOADS.STATUS[4].value
    };
  },
  methods: {
    ...mapActions({
      search: SHUTTLE_INBOUND_SEARCH,
      setAsArrived: SHUTTLE_INBOUND_SET_AS_ARRIVED
    }),
    async handleSubmit() {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      const confirm = await this.$confirm(this.$t('outbound.shuttleInbound.setAsArrivedConfirm'), { dangerouslyUseHTMLString: true, confirmButtonText: this.$t('outbound.shuttleInbound.arrived') }).catch(() => {});
      if (confirm) {
        const response = await this.setAsArrived(this.shuttleLoadId).catch(() => {});
        if (response && response.message) {
          this.$message.success(response.message);
        }
        this.search({});
      }
      loading.close();
    },
    isVisible() {
      const hasReleasedStatus = this.shuttleLoadStatus === this.releasedStatus;
      const hasPermission = this.$can(this.permissions.OUTBOUND.ARRIVAL_SHUTTLE_LOADS);
      return hasReleasedStatus && hasPermission;
    }
  }
};
</script>
